import ActionMenu from "../../../../../common/components/functional/actionMenu/ActionMenu";
import { AnchorElement } from "../../../../../common/types/commonTypes";
import { Clear as CancelIcon } from "@mui/icons-material";
import { ReactComponent as CheckIcon } from "../../../../../common/icons/checkGreen.svg";
import { useTranslation } from "react-i18next";

export type Props = {
  anchorEl: AnchorElement;
  onClose: () => void;
  selectActionForIntroduction: (id: string, action: string) => void;
};

const TalentIntroductionsActionMenu = ({
  anchorEl,
  onClose,
  selectActionForIntroduction,
}: Props) => {
  const { t } = useTranslation("talentProfile");

  const menuItems = [
    {
      key: "cancel",
      label: t("profileSummary.cancelIntroduction"),
      action: (key: string) =>
        selectActionForIntroduction(anchorEl?.id as string, key),
      icon: <CancelIcon sx={{ width: "16px", height: "16px" }} />,
    },
    {
      key: "accept",
      label: t("common:approve"),
      action: (key: string) =>
        selectActionForIntroduction(anchorEl?.id as string, key),
      textSx: { color: "success.main" },
      icon: <CheckIcon />,
    },
    {
      key: "reject",
      label: t("common:reject"),
      action: (key: string) =>
        selectActionForIntroduction(anchorEl?.id as string, key),
      textSx: { color: "error.main" },
      icon: (
        <CancelIcon
          sx={{ color: "error.main", width: "16px", height: "16px" }}
        />
      ),
    },
  ];

  return (
    <ActionMenu
      id="talentIntroducedToCustomerActionMenu"
      menuItems={menuItems}
      anchorEl={anchorEl}
      onClose={onClose}
    />
  );
};

export default TalentIntroductionsActionMenu;
